import { createContext } from 'react';
const NavContext = createContext({
    nav: {},
    setNav: () => {},
});
export default NavContext;
